import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { NewCustomerInput } from './NewCustomerInput';
import { NewCustomerOutput } from './NewCustomerOutput';

export class NewCustomerService extends HttpServiceBase {

  handle = (input: NewCustomerInput): Promise<Result<NewCustomerOutput> | null> => {
    const promise = this.http.post<Result<NewCustomerOutput>, NewCustomerInput>(`${this.baseUrlSislogApi}/v2/customer`, input);
    return promise;
  }
}